// This file is modified during CI builds. Do not change this
// file unless you know what you are doing
const APPLICATION_VERSION = "v1.454.15-TSS-2873-mcastro-ISSUE-Unable-to-change-client-name-after-campaign-is-created.0";

export const getApplicationVersion = (): string => APPLICATION_VERSION;
